import * as React from 'react'
// components
import Filter from './components/Filter/index'
import { Button } from '../Menu'
import { PopoverModal } from 'components/UI'
// context
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// themes
import MoreIcon from '@mui/icons-material/ArrowDropDown'
// utils
import debounce from 'lodash/debounce'
import { generateUserName } from 'utils/user'

const PAPER_PROPS = {
  style: {
    height: '524px',
    width: '300px'
  }
}

interface Props {
  handleSubmit: (handleFormSubmit: (data) => any) => any
}

const PersonFilter: React.FC<Props> = ({ handleSubmit }) => {
  const { usersFilter, handleSetUserSearch } = React.useContext(StrategyActionsBLContext)

  const personFilterTitle = React.useMemo(() => {
    if (usersFilter.length === 1) {
      const member = usersFilter[0] || {}

      if (member.firstName) {
        return generateUserName(member)
      }
      return member.description
    } else if (usersFilter.length > 1) {
      return 'Multiple'
    }

    return 'Everyone'
  }, [usersFilter])

  const handleFormSubmit = (data) => handleSetUserSearch(data.member)

  const handleSearch = debounce(handleSubmit(handleFormSubmit), 500)

  return (
    <PopoverModal
      trigger={
        <Button>
          {personFilterTitle}
          <MoreIcon color={'inherit'} fontSize={'large'} />
        </Button>
      }
      disableRestoreFocus
      PaperProps={PAPER_PROPS}>
      {({ closePopup }) => <Filter handleInputChange={handleSearch} closePopup={closePopup} />}
    </PopoverModal>
  )
}

export default PersonFilter
